"use client";

import { FaqBlock as FaqBlockTypes } from "@/payload-types";
import { RichText } from "@payloadcms/richtext-lexical/react";
import { ChevronDownIcon, ChevronUpIcon } from "flowbite-react";
import { useState } from "react";

export const FaqAccordion = (props: FaqBlockTypes) => {
  const { faqs } = props;
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div>
      <div className="divide-y divide-[#666666] border-b border-[#666666]">
        {faqs &&
          faqs.map((item, index) => (
            <div key={item.id} className="py-6">
              <button
                className="flex justify-between w-full text-left text-lg font-semibold focus:outline-none"
                onClick={() => toggleAccordion(index)}
              >
                <span>{item.faq.question}</span>
                <span>
                  {openIndex === index ? (
                    <ChevronUpIcon className="text-lg" />
                  ) : (
                    <ChevronDownIcon className="text-xl" />
                  )}
                </span>
              </button>

              <div
                className={`mt-2 transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === index
                    ? "max-h-screen opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="pt-2 text-black text-sm dark:text-white">
                  <RichText data={item.faq.answer} />
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
